// extracted by mini-css-extract-plugin
export default {"block":"block___IJZPP","learnMore":"learnMore___jjpy1"};